import styled from 'styled-components'

import { Heading4 } from '../../../shared/components/typography'

export const StContainer = styled.div``

export const StCountdown = styled(Heading4)``
